import React, { useRef } from 'react';

import '../css/video-popup.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function VideoPopup(props) {
  const iframe = useRef();

  const closePopup = e => {
    props.setVisible(false);
    iframe.current.setAttribute('src', iframe.current.src);
  };

  return (
    <section
      id='video-popup'
      onClick={closePopup}
      className={props.visible ? 'show' : 'hide'}
    >
      <div className='video-container'>
        <iframe
          ref={iframe}
          width='560'
          height='315'
          src='https://www.youtube.com/embed/NAeIEoyP3Ew'
          frameBorder='0'
          allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen='true'
          title='acting-reel'
        ></iframe>
      </div>
      <FontAwesomeIcon icon={faTimes} />
    </section>
  );
}

export default VideoPopup;
